// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Zp59","name":"Header_name__3O3ey","birthday":"Header_birthday__2G_MF","skeleton":"Header_skeleton__3O2W1"};